
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/automobile-insurance/um-uim-coverage-laws-regulations",
      function () {
        return require("private-next-pages/compliance/automobile-insurance/um-uim-coverage-laws-regulations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/automobile-insurance/um-uim-coverage-laws-regulations"])
      });
    }
  